import { FormControl } from '@angular/forms';

import { ValidationResult } from './validation-result';

export class BlankValidator {
  static valid(form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined) {
      const tamanho = form.value.length;
      const valor = form.value.toString().trim();
      if (tamanho > 0 && BlankValidator.empty(valor)) {
        return { required: true };
      }
    }
    return null;
  }

  static empty(mixedVar) {
    let key;
    const emptyValues = [undefined, null, false, 0, '', '0'];
    for (let i = 0; i < emptyValues.length; i++) {
      if (mixedVar === emptyValues[i]) {
        return true;
      }
    }
    if (typeof mixedVar === 'object') {
      for (key in mixedVar) {
        if (mixedVar.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/blank-validator.ts